export const initialFormValues = {
  economicGroup: '',
  profitCenter: '',
  budget: '',
  actualPreview: '',
  deviationVsBudget: '',
  accounts: [
    {
      account: '',
      returnJustification: '',
      userAndProfile: '',
      dateAndTime: '',
      validationPossibleUntil: ''
    }
  ]
}
